import { Link, useLocation } from "react-router-dom";
import { Home, Grid, User, ShoppingCart } from "lucide-react";
import { getCartCount } from "@/utils/cart";
import { useState, useEffect } from "react";

const NAV_ITEMS = [
  { label: "Home",       Icon: Home,         href: "/" },
  { label: "Categories", Icon: Grid,         href: "/shop" },
  { label: "Account",    Icon: User,         href: "/account" },
  { label: "Cart",       Icon: ShoppingCart, href: "/cart", showBadge: true },
];

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const [cartCount, setCartCount] = useState(getCartCount());

  useEffect(() => {
    const refresh = () => setCartCount(getCartCount());
    window.addEventListener("it_cart_updated", refresh);
    return () => window.removeEventListener("it_cart_updated", refresh);
  }, []);

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 safe-area-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-4 h-14">
        {NAV_ITEMS.map(({ label, Icon, href, showBadge }) => {
          const isActive = pathname === href || (href !== "/" && pathname.startsWith(href));
          return (
            <Link
              key={href}
              to={href}
              className={`flex flex-col items-center justify-center gap-0.5 relative transition-colors ${
                isActive ? "text-orange-500" : "text-slate-500"
              }`}
              data-testid={`bottom-nav-${label.toLowerCase()}`}
            >
              <div className="relative">
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 1.8} />
                {showBadge && cartCount > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-red-500 text-white text-[9px] font-black rounded-full flex items-center justify-center">
                    {cartCount > 9 ? "9+" : cartCount}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-semibold leading-none ${isActive ? "text-orange-500" : "text-slate-400"}`}>
                {label}
              </span>
              {isActive && (
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-orange-500 rounded-b-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
